import React from 'react';
import {FileListView} from 'src/app/forms/FormViewFileListRow/FileListView';
import {safeFileArrayParse} from 'src/app/forms/FormFileDropzone/utils/safeFileArrayParse';
import {FormViewRichTextEditor} from 'src/app/forms/FormViewRichTextEditor/FormViewRichTextEditor';
import {Stack} from 'src/design/atoms/Stack';
import {hasRichTextContent} from './contentPdf';

export interface ContentBodyProps {
  content?: unknown;
  contentPdfUrl?: unknown;
}

export const ContentBody: React.FC<ContentBodyProps> = ({
  content,
  contentPdfUrl,
}) => {
  const hasText = hasRichTextContent(content);
  const files = safeFileArrayParse(contentPdfUrl);
  if (!hasText && files.length === 0) return null;

  return (
    <Stack gap="md">
      {hasText && <FormViewRichTextEditor label="" value={content} />}
      {files.length > 0 && <FileListView files={files} renderAsImage />}
    </Stack>
  );
};
